<template lang="pug">
  .document
    .doc-name
      a(:href="doc.link" target="_blank") {{filename}}
    .doc-info
      b-badge(:variant="doc_type_style") {{doc_type}}
      b-badge(
        v-if="can_delete"
        class="doc-delete-link"
        variant="danger"
        @click="delete_file"
        ) удалить

</template>

<script>
export default {
  name: "DocumentItem",
  props: {
    can_delete: {
      type: Boolean,
      default: false,
    },
    doc: {
      type: Object,
      default: {
        doc_type: 'файл',
        link: '/download/0'
      }
    }
  },
  computed: {
    filename(){
      return this.doc.name || this.doc.filename
    },
    doc_type(){
      if (this.doc.doc_type === 'file') return `.${this.doc.extension}`;
      if (this.doc.doc_type === 'invoice') return `Счёт`;
      if (this.doc.doc_type === 'voucher') return `Ваучер`;
      return this.doc.doc_type;
    },
    doc_type_style(){
      if (this.doc.doc_type === 'file') return 'secondary';
      if (this.doc.doc_type === 'invoice') return 'primary';
      if (this.doc.doc_type === 'voucher') return 'dark';
      return 'secondary';
    }
  },
  methods:{
    delete_file(){
      if (confirm("Удалить файл навсегда?")) {
        this.$store.dispatch('docs/deleteDoc', {id: this.doc.id})
      } else {
        console.log('отмена')
      }
    },
  },
}
</script>

<style scoped>
  .document{
    /*border: 1px solid #dadee2;*/
    background-color: #edeff1;
    border-radius: 6px;
    padding: 5px;
    margin: 0 5px 5px 0;
  }
  .document .doc-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .document .doc-name {
    font-size: 14px;
    margin-bottom: 3px;
  }
  .document .doc-delete-link {
    display: none;
    cursor: pointer;
  }
  .document:hover .doc-delete-link {
    display: block;
  }

</style>